import { render } from "./Unit3-3-more.vue?vue&type=template&id=5f3ba582&scoped=true"
import script from "./Unit3-3-more.vue?vue&type=script&lang=js"
export * from "./Unit3-3-more.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit3-3-more.css?vue&type=style&index=1&id=5f3ba582&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3ba582"]])

export default __exports__